import { createContext, FC, useEffect, useMemo, useState } from 'react';

import { User, UserStatus } from '../../api';
import { setUserDefaultGroups } from '../../helpers/user';

export interface PrimarySettingsContextProps {
  defaultValues?: {
    defaultUserStatuses?: UserStatus[];
    bonusRestrictedGroups?: UserStatus[];
    bonusRestrictedCountries?: string[];
  };
}

export interface PrimarySettingsContextData {
  defaultUserStatuses: UserStatus[];
  bonusRestrictedGroups: UserStatus[];
  bonusRestrictedCountries: string[];
}

interface PrimarySettingsContextActions {
  updateDefaultUserStatuses: (
    countryCode?: string | undefined
  ) => (user: User) => User;
}

export const PrimarySettingsContext = createContext<
  PrimarySettingsContextData & PrimarySettingsContextActions
>(null as any);

const initialState = {
  defaultUserStatuses: [],
  bonusRestrictedGroups: [],
  bonusRestrictedCountries: [],
};

export const PrimarySettingsProvider: FC<PrimarySettingsContextProps> = ({
  children,
  defaultValues,
}) => {
  const [state, setState] = useState<PrimarySettingsContextData>(initialState);

  useEffect(() => {
    if (defaultValues) {
      setState((s) => ({ ...s, ...defaultValues }));
    }
  }, [defaultValues]);

  const updateDefaultUserStatuses = useMemo(
    () =>
      setUserDefaultGroups(
        state.defaultUserStatuses,
        state.bonusRestrictedGroups,
        state.bonusRestrictedCountries
      ),
    [
      state.defaultUserStatuses,
      state.bonusRestrictedGroups,
      state.bonusRestrictedCountries,
    ]
  );

  return (
    <PrimarySettingsContext.Provider
      value={{ ...state, updateDefaultUserStatuses }}
    >
      {children}
    </PrimarySettingsContext.Provider>
  );
};
